import React from 'react';
import { Badge } from '../ui/badge';
import { Kpis, Tabla, fechaAR } from './MigracionTabla';

const KPIS = [
  ['casos_abiertos', 'Casos abiertos'],
  ['clientes_con_duplicados', 'Clientes con más de un caso abierto'],
  ['casos_en_duplicados', 'Casos de esos clientes'],
  ['casos_a_fusionar', 'Casos a fusionar (pasan a CERRADO_POR_VINCULACION)'],
  ['principales_con_ros', 'Principales con ROS en curso'],
  ['responsables_heredados', 'Principales que toman responsable'],
  ['casos_sin_clave', 'Sin CUIT ni cliente_key (no se tocan)'],
  ['casos_fusionados', 'Fusionados ahora'],
  ['casos_omitidos', 'Omitidos (ya cerrados)'],
  ['pendientes_despues', 'Duplicados pendientes después'],
];

const PorEstado = ({ titulo, datos, testid }) => (
  <div className="border border-slate-200 rounded p-2" data-testid={testid}>
    <p className="text-[11px] text-slate-500 mb-1">{titulo}</p>
    {Object.entries(datos || {}).sort((a, b) => b[1] - a[1]).map(([estado, n]) => (
      <p key={estado} className="text-xs text-slate-700 flex justify-between"><span>{estado}</span><b>{n.toLocaleString('es-AR')}</b></p>
    ))}
  </div>
);

const cliente = (t) => <div><p className="font-medium">{t.nombre || '—'}</p><p className="font-mono text-slate-400">{t.cliente}</p></div>;

export const FusionDuplicadosResultado = ({ r }) => {
  const kpis = r.modo === 'EJECUTAR' ? KPIS : KPIS.filter(([k]) => !['casos_fusionados', 'casos_omitidos', 'pendientes_despues'].includes(k));
  return (
    <div className="space-y-4" data-testid="migracion-duplicados-resultado">
      <div className="flex items-center gap-2 text-sm">
        <Badge variant={r.modo === 'EJECUTAR' ? 'default' : 'secondary'}>{r.modo === 'EJECUTAR' ? 'Ejecutada' : 'Vista previa'}</Badge>
        <span className="text-slate-500">{new Date(r.inicio).toLocaleString('es-AR')}</span>
        {Object.keys(r.backups || {}).length > 0 && (
          <span className="text-xs text-emerald-700" data-testid="migracion-duplicados-backups">Backup: {Object.keys(r.backups).join(', ')}</span>
        )}
      </div>
      <Kpis defs={kpis} r={r} prefijo="migracion-duplicados" />
      <div className="grid grid-cols-2 gap-2">
        <PorEstado titulo="Casos principales por estado" datos={r.principales_por_estado} testid="migracion-duplicados-principales-estado" />
        <PorEstado titulo="Casos a fusionar por estado" datos={r.absorbidos_por_estado} testid="migracion-duplicados-absorbidos-estado" />
      </div>
      {r.clientes_con_mas_de_un_ros?.length > 0 && (
        <p className="text-xs text-amber-700" data-testid="migracion-duplicados-varios-ros">
          {r.clientes_con_mas_de_un_ros.length} cliente(s) tienen más de un caso con ROS en curso: el ROS del caso absorbido queda en ese caso.
        </p>
      )}
      <div>
        <p className="text-sm font-medium text-slate-700 mb-1">Los 10 clientes con más casos</p>
        <Tabla testid="migracion-duplicados-top" rows={r.top_clientes || []} cols={[
          [cliente, 'Cliente'], [(t) => t.casos, 'Casos'], [(t) => t.principal.titulo || t.principal.id, 'Caso principal'],
          [(t) => t.principal.estado, 'Estado'], [(t) => fechaAR(t.principal.creado), 'Creado'], [(t) => t.responsable || '—', 'Responsable'],
        ]} />
      </div>
      {r.sin_clave?.length > 0 && (
        <div>
          <p className="text-sm font-medium text-slate-700 mb-1">Casos sin CUIT ni cliente_key (no se tocan ni cuentan como pendientes)</p>
          <Tabla testid="migracion-duplicados-sin-clave" rows={r.sin_clave} cols={[
            [(c) => c.titulo || c.id, 'Caso'], [(c) => c.estado, 'Estado'], [(c) => fechaAR(c.creado), 'Creado'],
            [(c) => <span className="font-mono text-slate-400">{c.id}</span>, 'Id'],
          ]} />
        </div>
      )}
    </div>
  );
};
